import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import * as CONST from '../../../../constants/FieldsConst';
import {
  ADMIN_CONST,
  ENTITY_CONST,
  FAMILY_CONST,
  STUDENT_CONST,
  TEACHER_CONST,
  USER_CONST,
} from '../../../auth/login/LoginReducer';

const SelectRolesUsuarios = ({ value, onChanged, isAll = true }) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.rol.name}`}>{CONST.rol.label}</InputLabel>
      <Select
        id={CONST.rol.name}
        value={value}
        labelId={`label_${CONST.rol.name}`}
        label={CONST.rol.label}
        //   onChange={(e) => _handleSetDataField(CONST.rol.name, e.target.value)}
        onChange={(e) => onChanged(e.target.value)}
      >
        {isAll && <MenuItem value={null}>TODOS</MenuItem>}
        <MenuItem value={ADMIN_CONST}>ADMINISTRADOR</MenuItem>
        <MenuItem value={ENTITY_CONST}>ENTIDAD</MenuItem>
        <MenuItem value={TEACHER_CONST}>DOCENTE</MenuItem>
        <MenuItem value={FAMILY_CONST}>FAMILIAR</MenuItem>
        <MenuItem value={STUDENT_CONST}>ESTUDIANTE</MenuItem>
        <MenuItem value={USER_CONST}>USUARIO</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectRolesUsuarios;
